import { Exchange } from "@urql/core";

/**
 * An exchange that only forwards the operations it gets, used to sub for other exchanges
 * depending on config when you may want to omit them.  eg: Debug, devtools, etc.
 * @param forward
 * @constructor
 */
export const noopExchange: Exchange = ({ forward }) => {
  return op => forward(op);
};
